export default __webpack_public_path__ + "static/media/British_Airways.c2671e89.svg";